import { render, staticRenderFns } from "./goalPlan.vue?vue&type=template&id=83d4123c"
import script from "./goalPlan.vue?vue&type=script&lang=js"
export * from "./goalPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports